import ReactPDF, { View, Page, Text, StyleSheet, Font, Image } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
    page: {
        fontFamily: "Roboto",
        fontSize: 11,
        width: "100%",
        flexDirection: "column"
    },
    centerPage: {
        position: "relative",
        marginLeft: "10%",
        width: "80%",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    title: {
        marginTop: "3%",
        marginLeft: "5%",
        marginBottom: "2%",
        fontWeight: "bold",
        flexDirection: "row",
        alignItems: "center",
        fontSize: 20,
        color: "rgb(51, 102, 153)"
    },
    textTitle: {
        fontSize: 8,
        marginTop: "1%",
        marginLeft: "5%",
        marginBottom: "1%",
        fontWeight: "bold",
        flexDirection: "row",
        alignItems: "center",
        color: "rgb(51, 102, 153)"
    },
    text: {
        fontSize: 8,
        marginTop: "1%",
        marginLeft: "5%",
        marginRight: "5%",
        marginBottom: "1%",
        flexDirection: "row",
        alignItems: "center"
    },
    normalText: {
        fontSize: 10,
        marginTop: "1%",
        marginLeft: "5%",
        marginRight: "5%",
        marginBottom: "2%"
    },
    panel: {
        position: "relative",
        marginLeft: "5%",
        marginBottom: "2%",
        padding: "2% 2% 2% 2%",
        width: "90%",
        backgroundColor: "#f0f4fd",
        borderRadius: "20px"
    },
    header: {
        marginTop: "1%",
        fontWeight: "bold",
        color: "rgb(51, 102, 153)"
    },
    mt2: {
        marginTop: "5%"
    },
    center: {
        display: "flex",
        alignItems: "center"
    }
});